<template>
  <nuttrema-layout-west-slide width="35%" max-width="45em">

    <west-slide-left-navigation slot="navigation-top">
      <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white" @click="onCancelEvent"></nuttrema-iconica-sidebar-link>
    </west-slide-left-navigation>

    <nuttrema-layout-west-three-vertical>
      <div v-if="_has(meta, 'title')" slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <template slot="center">
        <nuttrema-loader v-if="SysAdminInstanceSubscriptionDetails.fetching || SysAdminInstanceSubscriptionInvoicesList.fetching"></nuttrema-loader>
        <form-instance-subscription-details
           v-else
          :meta="meta"
          :InstanceSubscriptionDetails="SysAdminInstanceSubscriptionDetails"
          :InstanceSubscriptionInvoicesList="SysAdminInstanceSubscriptionInvoicesList">
        </form-instance-subscription-details>
      </template>
    </nuttrema-layout-west-three-vertical>

    <router-view></router-view>

  </nuttrema-layout-west-slide>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import FormInstanceSubscriptionDetails from 'components/pages/professional/shared/instance-subscriptions/details/form-instance-subscription-details';

export default {
  name: 'page-instance-subscription-details',
  mixins: [PageProps],
  props: {
    instanceID: {
      required: true,
      default: null,
    },
    subscriptionID: {
      required: true,
      default: null,
    },
  },
  computed: {
    SysAdminInstanceSubscriptionDetails() {
      return this.$store.getters.SysAdminInstanceSubscriptionDetails(this.instanceID);
    },
    SysAdminInstanceSubscriptionInvoicesList() {
      return this.$store.getters.SysAdminInstanceSubscriptionInvoicesList(this.instanceID);
    },
  },
  components: {
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    FormInstanceSubscriptionDetails,
    NuttremaLayoutWestThreeVertical,
  },
  created() {
    this.$store.dispatch('GetSysAdminInstanceSubscriptionDetails', { instanceID: this.instanceID, subscriptionID: this.subscriptionID });
    this.$store.dispatch('GetSysAdminInstanceSubscriptionInvoicesList', { instanceID: this.instanceID, subscriptionID: this.subscriptionID });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearSysAdminInstanceSubscriptionDetails', { instanceID: this.instanceID });
    this.$store.dispatch('ClearSysAdminInstanceSubscriptionInvoicesList', { instanceID: this.instanceID });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/subscriptions/details/page-sys-admin-instance-subscription-details.vue